import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Table,
  Typography,
  Row,
  Col,
  Button,
  Popconfirm,
  message,
  Avatar,
  Divider,
  Tag,
  Modal,
  Form,
  Select,
  Input,
  Icon,
  InputNumber,
} from "antd";
import "./index.less";
import { platformApi } from "../../../../../api";
const { Title } = Typography;
const { Item } = Form;
const { Option } = Select;

const SIForm = ({
  visible,
  setVisible,
  getPSI,
  form
}) => {
  const {
    getFieldDecorator,
    setFieldsValue,
    getFieldValue,
    validateFields,
  } = form;
  const [error, setError] = useState({});
  const [searchPart, setSearchPart] = useState();
  const [selectedPart, setSelectedPart] = useState();
  const [branches, setBranches] = useState();
  const [branchData, setBranchData] = useState([]);
  const [masterBinLocations, setMasterBinLocations] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  let partsRef = {};

  const getBranchMasterBins = (masterBins, branchObj) => {
    if (!masterBins || masterBins.length === 0 || !branchObj) return [];
    const targetId = branchObj.id ? String(branchObj.id) : (typeof branchObj === 'string' ? branchObj : null);
    const targetName = branchObj.name ? String(branchObj.name).trim().toLowerCase() : (typeof branchObj === 'string' ? branchObj.trim().toLowerCase() : null);

    const filtered = masterBins.filter(b => {
      const bBranch = b.Branch || b.branch;
      const bBranchId = bBranch?.id || b.branchId || (typeof b.branch === 'string' ? b.branch : null);
      const bBranchName = bBranch?.name || (typeof b.branch === 'object' ? b.branch?.name : null);

      if (targetId && bBranchId && String(bBranchId) === targetId) {
        return true;
      }
      if (targetName && bBranchName && String(bBranchName).trim().toLowerCase() === targetName) {
        return true;
      }
      return false;
    });

    return filtered.sort((a, b) => {
      const timeA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const timeB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return timeA - timeB;
    });
  };

  useEffect(() => {
    if (visible) {
      platformApi.post("/api/binLocation/get", { page: 1, size: 500, searchString: "" })
        .then((res) => {
          let bins = [];
          if (res?.data?.code === 200) {
            bins = res.data.response?.data?.binLocation || [];
            setMasterBinLocations(bins);
          }
          getBranches(bins);
        })
        .catch((err) => {
          console.error("Error fetching bin location master: ", err);
          getBranches([]);
        });

      const search = {
        module: "partsMasters",
        column: "partNumber",
        fields: ["partNumber, partName"],
        searchString: "",
        searchColumns: ["partNumber"],
        setValue: setSearchPart,
      };
      searchParts(search);
    }
  }, [visible]);

  const getBranches = (currentMasterBins) => {
    const binsToUse = currentMasterBins || masterBinLocations;
    platformApi.get("/api/sparesInventory/branch/all").then((res) => {
      const { data } = res;
      if (data.code === 200) {
        const branchListRaw = data.response.data || [];
        setBranches(branchListRaw);

        let branchesFormatted = [];
        for (let item of branchListRaw) {
          const branchMasterBins = getBranchMasterBins(binsToUse, item);
          const extraLocs = branchMasterBins.length > 0
            ? branchMasterBins.map(b => ({ binNum: b.binLocation, phyQuantity: 0, accQuantity: 0, allocatedQuantity: 0 }))
            : [{ binNum: "", phyQuantity: 0, accQuantity: 0, allocatedQuantity: 0 }];

          let d = {
            key: item.id,
            branch: item.id,
            branchName: item.name,
            branchObj: item,
            accQuantity: 0,
            phyQuantity: 0,
            binNum: extraLocs[0]?.binNum || "",
            extraLocations: extraLocs
          };
          branchesFormatted.push(d);
        }
        setBranchData(branchesFormatted);
      }
    }).catch((err) => {
      console.error("Branch Fetch Error: ", err);
      message.error("Couldn't Fetch Branch");
    });
  };

  const clearFields = () => {
    setVisible(false);
    setError({});
    form.resetFields();
    setSelectedPart();
    setBranchData([]);
    setBranches();
    setExpandedRowKeys([]);
  };

  const toggleRowExpand = (record) => {
    const rowKey = record.key || record.branch;
    if (expandedRowKeys.includes(rowKey)) {
      setExpandedRowKeys(expandedRowKeys.filter((k) => k !== rowKey));
    } else {
      setExpandedRowKeys([...expandedRowKeys, rowKey]);
    }
  };

  const editExtraStock = (branchKey, subIdx, field, value) => {
    setBranchData((prevData) =>
      prevData.map((item) => {
        if (item.key === branchKey || item.branch === branchKey) {
          const extraCopy = [...(item.extraLocations || [])];
          let val = value;
          if (field !== "binNum" && typeof value === "number") {
            val = value < 0 ? 0 : value;
          }
          extraCopy[subIdx] = {
            ...extraCopy[subIdx],
            [field]: val,
          };

          const totalPhy = extraCopy.reduce(
            (sum, loc) => sum + (parseInt(loc.phyQuantity) || 0),
            0
          );

          let updatedItem = {
            ...item,
            extraLocations: extraCopy,
            phyQuantity: totalPhy,
            binNum: extraCopy[0]?.binNum || item.binNum,
          };
          if (subIdx === 0) {
            updatedItem[field] = val;
          }
          return updatedItem;
        }
        return item;
      })
    );
  };

  const editBranchData = (name, value, data) => {
    let allData = [...branchData];
    let newValue = value;
    if (name === "accQuantity" || name === "phyQuantity") {
      newValue = value < 0 ? 0 : value;
    }
    for (let item of allData) {
      if (data.branch === item.branch || data.key === item.key) {
        item[name] = newValue;
        if (item.extraLocations && item.extraLocations.length > 0) {
          const extraCopy = [...item.extraLocations];
          extraCopy[0] = { ...extraCopy[0], [name]: newValue };
          item.extraLocations = extraCopy;
        }
        break;
      }
    }
    setBranchData(allData);
  };

  const renderExtendedRows = (record) => {
    const branchMasterBins = getBranchMasterBins(masterBinLocations, record.branchObj || { id: record.branch, name: record.branchName });

    let extraLocs = record.extraLocations || [];
    if (extraLocs.length === 0 && branchMasterBins.length > 0) {
      extraLocs = branchMasterBins.map((b) => ({
        phyQuantity: 0,
        accQuantity: 0,
        allocatedQuantity: 0,
        binNum: b.binLocation,
      }));
    } else if (extraLocs.length === 0) {
      extraLocs = [{ phyQuantity: 0, accQuantity: 0, allocatedQuantity: 0, binNum: "" }];
    }

    const isScrollable = extraLocs.length > 4;

    return (
      <div
        style={{
          backgroundColor: "#f0f2f5",
          paddingLeft: "5px",
          maxHeight: isScrollable ? "250px" : "none",
          overflowY: isScrollable ? "auto" : "visible",
        }}
      >
        <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse", margin: 0 }}>
          <colgroup>
            <col style={{ width: 100 }} />
            <col style={{ width: 160 }} />
            <col style={{ width: 75 }} />
            <col style={{ width: 75 }} />
            <col style={{ width: 60 }} />
          </colgroup>
          <tbody>
            {extraLocs.map((subItem, subIdx) => {
              const subBinVal = subItem.binNum || (branchMasterBins[subIdx] ? branchMasterBins[subIdx].binLocation : undefined);
              return (
                <tr key={subIdx}>
                  {/* Col 1: Branch Name space */}
                  <td style={{ padding: "8px 0px" }} />

                  {/* Col 2: Bin Location (moved to the left) */}
                  <td style={{ padding: "8px 16px 8px 52px", verticalAlign: "middle" }}>
                    <Input
                      style={{ width: "100%" }}
                      placeholder="Bin Location"
                      value={subBinVal || ""}
                      onChange={(e) => editExtraStock(record.key, subIdx, "binNum", e.target.value)}
                    />
                  </td>

                  {/* Col 3: Physical Qty (moved to the right to align with main row Physical Qty) */}
                  <td style={{ padding: "8px 8px 8px 14px", verticalAlign: "middle" }}>
                    <InputNumber
                      style={{ width: "100%" }}
                      min={0}
                      placeholder="0"
                      value={subItem.phyQuantity}
                      onChange={(val) => editExtraStock(record.key, subIdx, "phyQuantity", val)}
                    />
                  </td>

                  {/* Col 4: Accounting Qty space (hidden accQty input as requested) */}
                  <td style={{ padding: "8px 8px", verticalAlign: "middle" }} />

                  {/* Col 5: Action space */}
                  <td style={{ padding: "8px 8px" }} />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const columns = [
    {
      title: "Branch Name",
      dataIndex: "branchName",
      key: "branchName",
      width: 120,
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Bin Location",
      dataIndex: "binNum",
      key: "binNum",
      width: 140,
      render: (record, data) => {
        return (
          <Input
            placeholder=""
            value=""
            name="binNum"
            disabled={true}
          />
        );
      },
    },
    {
      title: "Physical Qty",
      dataIndex: "phyQuantity",
      key: "phyQuantity",
      width: 75,
      render: (record, data) => {
        const totalPhy = (data.extraLocations && data.extraLocations.length > 0)
          ? data.extraLocations.reduce((sum, loc) => sum + (parseInt(loc.phyQuantity) || 0), 0)
          : (data.phyQuantity || 0);

        return (
          <InputNumber
            placeholder="Physical Qty"
            min={0}
            style={{ width: "100%" }}
            value={totalPhy}
            onChange={(val) => editBranchData("phyQuantity", val, data)}
          />
        );
      },
    },
    {
      title: "Accounting Qty",
      dataIndex: "accQuantity",
      key: "accQuantity",
      width: 75,
      render: (record, data) => {
        return (
          <InputNumber
            placeholder="Accounting Qty"
            min={0}
            style={{ width: "100%" }}
            value={record}
            onChange={(val) => editBranchData("accQuantity", val, data)}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: 60,
      align: "center",
      render: (text, record) => {
        const rowKey = record.key || record.branch;
        const isExpanded = expandedRowKeys.includes(rowKey);
        return (
          <Icon
            type={isExpanded ? "up" : "down"}
            style={{
              color: "#00565b",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
              padding: "4px"
            }}
            onClick={() => toggleRowExpand(record)}
          />
        );
      },
    },
  ];

  const handleSubmit = () => {
    validateFields((err) => {
      if (err == null) {
        const branchPayload = branchData.map((item) => {
          const branchMasterBins = getBranchMasterBins(masterBinLocations, item.branchObj || { id: item.branch, name: item.branchName });

          const extraList = item.extraLocations || [];
          const totalPhyQty = extraList.length > 0
            ? extraList.reduce((sum, l) => sum + (parseInt(l.phyQuantity) || 0), 0)
            : parseInt(item.phyQuantity || 0);

          const firstLoc = extraList[0] || {};
          const loc1Bin = firstLoc.binNum || item.binNum || (branchMasterBins.length > 0 ? branchMasterBins[0].binLocation : "");

          const loc1 = {
            phyQuantity: parseInt(firstLoc.phyQuantity !== undefined ? firstLoc.phyQuantity : (item.phyQuantity || 0)),
            accQuantity: parseInt(firstLoc.accQuantity !== undefined ? firstLoc.accQuantity : (item.accQuantity || 0)),
            allocatedQuantity: parseInt(firstLoc.allocatedQuantity !== undefined ? firstLoc.allocatedQuantity : (item.allocatedQuantity || 0)),
            binNum: loc1Bin
          };

          const validExtras = extraList.slice(1).map((l, idx) => ({
            phyQuantity: parseInt(l.phyQuantity || 0),
            accQuantity: parseInt(l.accQuantity || 0),
            allocatedQuantity: parseInt(l.allocatedQuantity || 0),
            binNum: l.binNum || (branchMasterBins[idx + 1] ? branchMasterBins[idx + 1].binLocation : "")
          })).filter(l => l.binNum || l.phyQuantity > 0);

          const allLocations = [loc1, ...validExtras];

          return {
            branch: item.branch,
            binNum: loc1Bin,
            addressType: allLocations.length > 1 ? "DIFFERENT" : "SAME",
            binLocations: JSON.stringify(allLocations),
            reorderQuantity: parseInt(item.reorderQuantity || 0),
            maxStock: parseInt(item.maxStock || 0),
            minStock: parseInt(item.minStock || 0),
            reorderLevel: parseInt(item.reorderLevel || 0),
            phyQuantity: totalPhyQty,
            accQuantity: parseInt(item.accQuantity || 0),
            allocatedQuantity: parseInt(item.allocatedQuantity || 0)
          };
        });

        platformApi.post("/api/sparesInventory", {
          part: selectedPart,
          branch: branchPayload
        }).then((res) => {
          message.success("Spare Created Successfully");
          getPSI();
          clearFields();
        }).catch((err) => {
          console.error("Spare creation error: ", err);
          message.error("Couldn't create Spare Inventory");
        });
      }
    });
  };

  const searchParts = (search) => {
    platformApi.post('/api/options/get', {
      module: search.module,
      column: search.column,
      searchString: search.searchString,
      fields: search.fields,
      size: 100,
      searchColumns: search.searchColumns,
    }).then((res) => {
      const { data } = res;
      if (data.code === 200) {
        search.setValue(data.response);
      }
    }).catch((err) => {
      console.error("Part Fetch Error: ", err);
      message.error("Couldn't Fetch Parts");
    });
  };

  const selectingPart = (e) => {
    for (let item of searchPart) {
      if (item.id === e) {
        setSelectedPart(item);
        break;
      }
    }
    platformApi.post("/api/sparesInventory/getPart", {
      partNo: e
    }).then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          let dataList = [];
          for (let item of response.data.sparesInventory) {
            let filterData = response.data.sparesInventory.filter((i) => i.partNo.id === item.partNo.id);
            let fl = true;
            for (let d of dataList) {
              for (let item2 of filterData) {
                if (item2.id === d[0].id) {
                  fl = false;
                  break;
                }
              }
              if (fl === false) break;
            }
            if (fl) {
              dataList.push(filterData);
            }
          }

          let finalData = [];
          if (dataList.length) {
            for (let item of dataList) {
              if (item.length === 1) {
                let newData = item[0];
                newData.branch = [{
                  partId: newData.partNo.id,
                  sparesId: item[0].id,
                  branch: item[0].branch,
                  binNum: item[0].binNum,
                  phyQuantity: item[0].phyQuantity,
                  accQuantity: item[0].accQuantity,
                  binLocations: item[0].binLocations
                }];
                finalData.push(newData);
              } else {
                let newData = item[0];
                let branch = [];
                for (let d of item) {
                  branch.push({
                    partId: d.partNo.id,
                    sparesId: d.id,
                    branch: d.branch,
                    binNum: d.binNum,
                    phyQuantity: d.phyQuantity,
                    accQuantity: d.accQuantity,
                    binLocations: d.binLocations
                  });
                }
                newData.branch = branch;
                finalData.push(newData);
              }
            }
          }

          let branchesList = branches || [];
          let existingBranches = finalData.length ? (finalData[0].branch || []) : [];

          let mergedBranches = branchesList.map((b) => {
            const existing = existingBranches.find((eb) => eb.branch?.id === b.id);
            const branchMasterBins = getBranchMasterBins(masterBinLocations, b);

            let parsedLocs = [];
            if (existing?.binLocations) {
              try {
                parsedLocs = typeof existing.binLocations === 'string'
                  ? JSON.parse(existing.binLocations)
                  : existing.binLocations;
              } catch (err) {
                parsedLocs = [];
              }
            }

            let extraLocs = parsedLocs.length > 0 ? [...parsedLocs] : [];
            branchMasterBins.forEach((mb) => {
              const bName = (mb.binLocation || "").trim().toLowerCase();
              const exists = extraLocs.some(
                (e) => (e.binNum || e.binLocation || "").trim().toLowerCase() === bName
              );
              if (!exists) {
                extraLocs.push({
                  binNum: mb.binLocation,
                  phyQuantity: 0,
                  accQuantity: 0,
                  allocatedQuantity: 0,
                });
              }
            });

            if (extraLocs.length === 0) {
              extraLocs = [{ binNum: existing?.binNum || "", phyQuantity: existing?.phyQuantity || 0, accQuantity: existing?.accQuantity || 0 }];
            }

            const totalPhy = extraLocs.reduce((sum, loc) => sum + (parseInt(loc.phyQuantity) || 0), 0);

            return {
              key: b.id,
              branch: b.id,
              branchName: b.name,
              branchObj: b,
              accQuantity: existing ? (existing.accQuantity != null ? existing.accQuantity : "") : "",
              phyQuantity: totalPhy,
              binNum: extraLocs[0]?.binNum || existing?.binNum || "",
              extraLocations: extraLocs
            };
          });

          setBranchData(mergedBranches);
        } else {
          message.error('Unable to fetch part details', 2);
        }
      } else {
        message.error('Unable to fetch part details', 2);
      }
    }).catch((err) => {
      console.error("PSI Fetch Error: ", err);
      message.error("Couldn't Fetch PSI");
    });
  };

  return (
    <Modal
      wrapClassName="pmc-form"
      visible={visible}
      title="Add Spares"
      okButtonProps={{}}
      onCancel={() => { clearFields(); }}
      onOk={handleSubmit}
      okText={"Save"}
    >
      <Form>
        <Row>
          <Col span={11}>
            <Item label="Part No">
              {getFieldDecorator("part", {
                rules: [{ required: true, message: "Select Part" }]
              })(
                <Select
                  dropdownStyle={{
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                  showSearch
                  showAction={["click", "focus"]}
                  filterOption={null}
                  onSearch={(e) => {
                    const search = {
                      module: "partsMasters",
                      column: "partNumber",
                      fields: ["partNumber, partName"],
                      searchString: e,
                      searchColumns: ["partNumber"],
                      setValue: setSearchPart,
                    };
                    searchParts(search);
                    if (searchPart?.length === 1) {
                      selectingPart(searchPart[0].id);
                      if (partsRef[0]) partsRef[0].focus();
                    }
                  }}
                  onSelect={(e) => { selectingPart(e); }}
                  placeholder="Part Number"
                  style={{ width: '100%' }}
                >
                  {searchPart && searchPart.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.partNumber}
                    </Option>
                  ))}
                </Select>
              )}
            </Item>
          </Col>
          <Col span={1} />
          <Col span={11}>
            <Item label="Part Name">
              <Input
                disabled={true}
                value={selectedPart && selectedPart.partName}
                placeholder="Part No"
              />
            </Item>
          </Col>
        </Row>
        <Row>
          <Table
            style={{ marginTop: '1rem' }}
            columns={columns}
            tableLayout="fixed"
            rowKey="key"
            dataSource={branchData}
            expandedRowKeys={expandedRowKeys}
            onExpandedRowsChange={(keys) => setExpandedRowKeys(keys)}
            expandedRowRender={(record) => renderExtendedRows(record)}
            expandIconAsCell={false}
            expandIconColumnIndex={-1}
          />
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedSIForm = Form.create({ name: "SIForm" })(SIForm);
export default WrappedSIForm;